export default __webpack_public_path__ + "static/media/mysugr_coach_voucher_based_1.5e9c6a92.webp";